import { createTheme } from '@mui/material/styles';

/**
 * MUI theme aligned to the AgencyOS brand palette (see src/index.css).
 * Use by wrapping a subtree in <ThemeProvider theme={muiTheme}>.
 */
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#0a202e', // --color-deep-blue
      contrastText: '#20cbd4', // --color-bright-blue
    },
    secondary: {
      main: '#20cbd4', // --color-bright-blue
      contrastText: '#0a202e',
    },
    background: {
      default: '#f8fafc',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: 'inherit',
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
  },
});
